import { render, staticRenderFns } from "./resourcesExport.vue?vue&type=template&id=76f842d5&"
import script from "./resourcesExport.vue?vue&type=script&lang=js&"
export * from "./resourcesExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports